import { screenSmallerThan } from '../../../shared/utilities/screenSize';
import { whenInView } from '../../../shared/utilities/when-in-view';

class RowColumnAnimation {
	setupAnimation(element) {
		this.addAnimationDelays(element);
		this.showAnimation(element);
	}

	addAnimationDelayMobile(container, selector) {
		container.querySelectorAll(selector).forEach((row, index) => {
			row.querySelector('.instrument.first').style.animationDelay = 0.1 * (index + 1) + 's';
			row.querySelector('.info-content').style.animationDelay = 0.1 * (index + 1) + 's';
		});
	}

	addAnimationDelayDesktop(selector) {
		// find numner of td in each row and then apply logic for row index
		const row = selector.querySelector('tbody tr:first-child');
		if (row) {
			const tdInARow = row.childElementCount;
			const totalTd = Array.from(selector.querySelectorAll('tbody td'));
			totalTd.forEach((td, index) => {
				const rowIndex = Math.ceil((index + 1) / tdInARow);
				td.style.animationDelay = 0.1 * rowIndex + 's';
			});
		}
	}

	addAnimationDelays(element) {
		if (!screenSmallerThan('sm')) {
			this.addAnimationDelayDesktop(element);
			return;
		}

		const selector =
			element.dataset.element === 'inspiration-table'
				? '.inspiration-table__content-section-mobile .inspiration-table__row'
				: '.table-mobile .dynamic-pricing__row';
		this.addAnimationDelayMobile(element, selector);
	}

	getAnimatingElement(element) {
		return element.querySelector(screenSmallerThan('sm') ? '.table-container' : 'tbody');
	}

	addAnimationClass(element) {
		this.getAnimatingElement(element).classList.add('animating');
	}

	removeAnimationClass(element) {
		this.getAnimatingElement(element).classList.remove('animating');
	}

	showAnimation(element) {
		return whenInView(element, { threshold: 0.25 }).then(() => {
			this.addAnimationClass(element);
		});
	}
}

const rowColumnAnimation = new RowColumnAnimation();
export default rowColumnAnimation;
